<template>
  <div class="animated fadeIn">
    <br>
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Generar Informes</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          
          <b-row class="my-1">
              <b-col sm="2">
                <label style="text-aling:rigth">Informe</label>
              </b-col>
              <b-col sm="3">
                  <b-form-group>
                    <b-form-select
                        :options="informes"
                        v-model="datosFormulario.informe">
                    </b-form-select>
                  </b-form-group>
              </b-col>
          </b-row>

          <!-- Monto Asegurado v/s Prima -->
          <b-row class="my-1" v-if="datosFormulario.informe == 2">
              <b-col sm="2">
                <label>Moneda</label>
              </b-col>
              <b-col sm="2">
                  <b-form-group>
                    <b-form-select
                        :options="monedas"
                        v-model="datosFormulario.moneda">
                    </b-form-select>
                  </b-form-group>
              </b-col>
          </b-row>

          <b-row class="my-1" v-if="datosFormulario.informe == 2 || datosFormulario.informe == 3">
            <b-col sm="2">
              <label>Fecha Desde</label>
            </b-col>
            <b-col sm="3">
                <b-form-group>
                  <b-input-group>
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-calendar"></i>
                      </span>
                    </div>
                    <datepicker
                      :language="es"
                      format="dd/MM/yyyy"
                      :use-utc="true"
                      input-class="form-control"
                      v-model="datosFormulario.desde"
                      :disabled="campoBloqueado('desde', 'datosFormulario')"
                    ></datepicker>
                  </b-input-group>
                </b-form-group>
            </b-col>
          </b-row>

          <b-row class="my-1" v-if="datosFormulario.informe == 2 || datosFormulario.informe == 3">
            <b-col sm="2">
              <label>Fecha Hasta</label>
            </b-col>
            <b-col sm="3">
                <b-form-group>
                  <b-input-group>
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-calendar"></i>
                      </span>
                    </div>
                    <datepicker
                      :language="es"
                      format="dd/MM/yyyy"
                      :use-utc="true"
                      input-class="form-control"
                      v-model="datosFormulario.hasta"
                      :disabled="campoBloqueado('hasta', 'datosFormulario')"
                    ></datepicker>
                  </b-input-group>
                </b-form-group>
            </b-col>
          </b-row>
          <!-- fin -->


          <div slot="footer">
                <div class="form-actions text-right">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="generar"><i class="fa fa-file-excel-o"></i> Generar Informe</b-button>
                                <b-button variant="primary" @click="pre_insertar" style="margin-left: 10px;"><i class="fa fa-eraser"></i> Limpiar</b-button>
                            </el-col>                                
                    </el-row>                
                </div>
            </div>            
        </b-card>
        

      </b-col>
    </b-row>

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiInfAtradius from "@/components/services/apiInfAtradius";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "GenerarInformes",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      hasPoliza : false,
      exportar: false,
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },
      data: [],
      data2: [],
      monedas: [],
      informes: [],


      nombreexcel: "GenerarInformes",
      titles_AprobLinea: [
        {
          prop: "n",
          label: "N°",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "National Id",
          label: "National Id",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "Customer",
          label: "Customer",
          align: "center",
          minwidth:'200'
        },
        {
          prop: "Country",
          label: "Country",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "Validity Period From",
          label: "Validity Period From",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "Validity Period Until",
          label: "Validity Period Until",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "Currency",
          label: "Currency",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "Requested Amount",
          label: "Requested Amount",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "Approved Amount",
          label: "Approved Amount",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "%",
          label: "%",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "Status",
          label: "Status",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "Use",
          label: "Use",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "Sales Conditions",
          label: "Sales Conditions",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "Business Lines",
          label: "Business Lines",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "Term (days)",
          label: "Term (days)",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "Comments (Spanish)",
          label: "Comments (Spanish)",
          align: "center",
          minwidth:'120'
        },
      ],
      titles_Prima: [
        {
          prop: "PRODUCT",
          label: "PRODUCT",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "POLICY",
          label: "POLICY",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "DOCUMENT",
          label: "DOCUMENT",
          align: "center",
          minwidth:'200'
        },
        {
          prop: "TYPE",
          label: "TYPE",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "ENDORSEMENT",
          label: "ENDORSEMENT",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "ENDORSEMENT ISSUE DATE",
          label: "ENDORSEMENT ISSUE DATE",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "SALES DATE",
          label: "SALES DATE",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "TOTAL PREMIUM",
          label: "TOTAL PREMIUM",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "INSURANCE TO",
          label: "INSURANCE TO",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "APR",
          label: "APR",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "INSURED NAME",
          label: "INSURED NAME",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "CURRENCY",
          label: "CURRENCY",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "SUBSIDIARY",
          label: "SUBSIDIARY",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "YEAR",
          label: "YEAR",
          align: "center",
          minwidth:'120'
        }
      ],
      titles_SiniExcel_payments: [
        {
          prop: "INSURED",
          label: "INSURED",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "POLICY",
          label: "POLICY",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "DEBTOR",
          label: "DEBTOR",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "TAX IDENTIFICATION NUMBER",
          label: "TAX IDENTIFICATION NUMBER",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "TYPE OF CUSTOMER",
          label: "TYPE OF CUSTOMER",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "CLAIM NUMBER",
          label: "CLAIM NUMBER",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "TYPE OF PAYMENT",
          label: "TYPE OF PAYMENT",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "TYPE OF RECOVERIES",
          label: "TYPE OF RECOVERIES",
          align: "center",
          minwidth:'80'
        },
        
        {
          prop: "RECEPTOR",
          label: "RECEPTOR",
          align: "center",
          minwidth:'80'
        },
        
        {
          prop: "PAYMENT DATE",
          label: "PAYMENT DATE",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "AMOUNT $",
          label: "AMOUNT $",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "POLICY CURRENCY",
          label: "POLICY CURRENCY",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "AMOUNT",
          label: "AMOUNT",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "SUBSIDIARY",
          label: "SUBSIDIARY",
          align: "center",
          minwidth:'80'
        },
      ],
      titles_SiniExcel_provisions:[
        {
          prop: "INSURED",
          label: "INSURED",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "POLICY",
          label: "POLICY",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "PRODUCT",
          label: "PRODUCT",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "DEBTOR",
          label: "DEBTOR",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "TAX IDENTIFICATION NUMBER",
          label: "TAX IDENTIFICATION NUMBER",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "TYPE OF CUSTOMER",
          label: "TYPE OF CUSTOMER",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "CLAIM NUMBER",
          label: "CLAIM NUMBER",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "STATUS",
          label: "STATUS",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "POLICY CURRENCY",
          label: "POLICY CURRENCY",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "POLICY CURRENCY PROVISION",
          label: "POLICY CURRENCY PROVISION",
          align: "center",
          minwidth:'80'
        },
        //TYPE OF CLAIM
        {
          prop: "TYPE OF CLAIM",
          label: "TYPE OF CLAIM",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "SUBSIDIARY",
          label: "SUBSIDIARY",
          align: "center",
          minwidth:'80'
        },
      ]
      ,
      titles_SiniExcel_provisions_old: [
        {
          prop: "POLICY",
          label: "POLICY",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "INSURED",
          label: "INSURED",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "CLAIM NUMBER",
          label: "CLAIM NUMBER",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "DEBTOR",
          label: "DEBTOR",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "TAX IDENTIFICATION NUMBER",
          label: "TAX IDENTIFICATION NUMBER",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "TYPE OF CUSTOMER",
          label: "TYPE OF CUSTOMER",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "STATUS",
          label: "STATUS",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "TYPE OF CLAIM",
          label: "TYPE OF CLAIM",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "STATUS DATE",
          label: "STATUS DATE",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "PROVISIONS TOTAL AMOUNT  $",
          label: "PROVISIONS TOTAL AMOUNT  $",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "POLICY CURRENCY",
          label: "POLICY CURRENCY",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "TOTAL AMOUNT",
          label: "TOTAL AMOUNT",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "INSURED PROVISION",
          label: "INSURED PROVISION",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "LIQUIDATOR PROVISIONS",
          label: "LIQUIDATOR PROVISIONS",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "OTHERS PROVISIONS",
          label: "OTHERS PROVISIONS",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "CONFIGURATION DATE",
          label: "CONFIGURATION DATE",
          align: "center",
          minwidth:'80'
        },
        {
          prop: "SUBSIDIARY",
          label: "SUBSIDIARY",
          align: "center",
          minwidth:'80'
        },
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              if (prop === 'desde'){
                let elDate = new Date(row["desde"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else if (prop === 'hasta'){
                let elDate = new Date(row["hasta"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              }
              else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

      
      datosFormulario: {
          informe: "",
          moneda: "",
          desde : "",
          hasta: "",
          pais: "",
          hoy: "",
          codPais:""
      },

      value: null,
      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      
      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "poliza"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
    cambiarFechas(){
      if(this.datosFormulario.selected == 'A') {
            this.mostrarFechas = false;
      }else{
            this.mostrarFechas = true;
      }
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },

    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },
    
    pre_insertar() {
      this.$Progress.start(); 
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.informes = [];
      this.value = null;

      this.datosFormulario.informe = "1";
      this.datosFormulario.moneda="";
      this.datosFormulario.desde ="";
      this.datosFormulario.hasta ="";
      this.datosFormulario.pais ="";
      this.datosFormulario.codPais="";
      
      return apiInfAtradius
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }

          var lista_data = response.data.res;
          for (var i = 0; i < lista_data.length; i++) {
            this.datosFormulario.hasta = lista_data[i]["hasta"];
            this.datosFormulario.desde = lista_data[i]["desde"];
            this.datosFormulario.moneda = lista_data[i]["moneda"];
            this.datosFormulario.pais = lista_data[i]["pais"];
            this.datosFormulario.hoy = lista_data[i]["hoy"];
            this.datosFormulario.codPais=lista_data[i]["codpais"];

          }
          
          this.datosFormularioEstado = response.data.festado;
          
          //carga de listados
          this.monedas = this.llenaArrayLista(response.data.monedas, 'codigo', 'nombre', false);

          var obj = new Object();
          obj.value = "1";
          obj.text = "Porcentaje de Aprobación de Líneas";
          this.informes.push(obj);

          var obj2 = new Object();
          obj2.value = "2";
          obj2.text = "Monto Asegurado v/s Prima";
          this.informes.push(obj2);

          var obj3 = new Object();
          obj3.value = "3";
          obj3.text = "Estado de Siniestros";
          this.informes.push(obj3);
          

          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
          this.$Progress.finish();
        });
    },

    formatter(row, column) {
      if ((column.property == "desde" || column.property == "hasta" 
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
        if (row[column.property] == 0 || row[column.property] == "0") {
          return row[column.property];
        } else {
          return this.$numeral(row[column.property]).format("0,0.00");
        }
      } else {
        return row[column.property];
      }
    },
    
    export:async function(data, filename) {
      if(typeof this.beforeFinish === 'function')
        await this.beforeFinish();
      download(data, filename,  "application/vnd.ms-excel");
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    generar() {
      if (this.datosFormulario.informe == 1) {
        this.recuperar_AprobLinea();
      }else if (this.datosFormulario.informe == 2){
        this.recuperar_Prima();
      }else if (this.datosFormulario.informe == 3){
        this.recuperar_SiniExcel();
      }else{
        this.crearNotificacion("Error de sistema", "Informe no disponible", "error");
      }
    },

    recuperar_AprobLinea() {
      this.$Progress.start();
      this.nombreexcel =  "Credit Limits (" + this.datosFormulario.hoy + ') ' + this.datosFormulario.pais + '.xls';
      return apiInfAtradius
      .recuperar_AprobLinea(
        this.$session.get("mail"),
        this.$session.get("usuarioInterno")
        ).then( (response)=>{
            response.data = this.keysMinuscula(response.data); 
            this.data = response.data.res;
            this.data2 = response.data.restc;

            this.excel_AprobLinea();

            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    recuperar_Prima() {
      this.$Progress.start();
      var fecha = new Date(this.datosFormulario.hasta );
      var periodo;  
      var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
      var año = fecha.getUTCFullYear();

      periodo =  mes + '-' + año;  

      this.nombreexcel =  "Premium (" + periodo + ') ' + this.datosFormulario.pais + '.xls';
      return apiInfAtradius
      .recuperar_Prima(
        this.$session.get("mail"),
        this.$session.get("usuarioInterno"),
        this.datosFormulario.moneda,
        this.convierteFecha(this.datosFormulario.desde),
        this.convierteFecha(this.datosFormulario.hasta)
        ).then( (response)=>{
            response.data = this.keysMinuscula(response.data); 
            
            this.data = response.data.res;
            this.data2 = response.data.restc;

            this.excel_Prima();

            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    recuperar_SiniExcel() {
      this.$Progress.start();
      
      return apiInfAtradius
      .recuperar_SiniExcel(
        this.$session.get("mail"),
        this.$session.get("usuarioInterno"),
        this.convierteFecha(this.datosFormulario.desde),
        this.convierteFecha(this.datosFormulario.hasta)
        ).then( (response)=>{
            response.data = this.keysMinuscula(response.data); 
            
            this.data = response.data.respagos;
            this.data2 = response.data.resprovi;
            
            this.excel_SiniExcel_pagos();
            this.excel_SiniExcel_provisiones();

            this.$Progress.finish();
        })
        .catch((error)=>{
          this.$Progress.finish();
          this.mensaje= error;
          this.variant="danger";
          this.showAlert();
        });
    },

    excel_AprobLinea: function () {
      var cuerpo = "";
      var columnas = this.titles_AprobLinea;
      var polizaAnterior = 0;
      var filaActual = 1;
      var sumaMontoSol = 0;
      var sumaMontoApr = 0;
      var porcentajeSuma = 0;
      var muestraPoliza = false;

      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:10.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:10.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl64961t = "padding:0px; mso-ignore:padding; color:black; font-size:10.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:\"@\"; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      
      
      
      for (var key in this.data) {
      
        if (this.data[key]["linpoliza"] != polizaAnterior){
          
          if (polizaAnterior != 0){
            cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
            cuerpo += "<td colspan=" + 6 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'></td>\n";
            cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>Total</td>\n";
            cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>"+ this.$numeral(sumaMontoSol).format("0,0.00") +"</td>\n";
            cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>"+ this.$numeral(sumaMontoApr).format("0,0.00") +"</td>\n";
            cuerpo += "</tr>\n";

            cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
            cuerpo += "<td colspan=" + 6 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'></td>\n";
            cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>Approval %</td>\n";
            
            if (sumaMontoApr == 0){
              porcentajeSuma = 0;  
            }else{
              porcentajeSuma = sumaMontoApr / sumaMontoSol;
              porcentajeSuma = porcentajeSuma * 100;
            }
            
            cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>"+ this.$numeral(porcentajeSuma).format("0%") +"</td>\n";
            cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'></td>\n";
            cuerpo += "</tr>\n";

            cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
            cuerpo += "</tr>\n";
            cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
            cuerpo += "</tr>\n";
          }
          
          sumaMontoSol = 0;
          sumaMontoApr = 0;
          filaActual = 1
          cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
          cuerpo += "<td colspan=" + 3 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>"+this.data[key]["contratante"]+"</td>\n";
          cuerpo += "<td colspan=" + 2 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>EXCHANGE RATE: "+this.data2[0]["fecha"]+"</td>\n";
          cuerpo += "</tr>\n";
          muestraPoliza=true;

          for (var key2 in this.data2) {

            if (this.data2[key2]["marpoliza"] == this.data[key]["linpoliza"]){
              cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
              cuerpo += "<td colspan=" + 3 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>"+(muestraPoliza == true? this.data[key]["linpoliza"]: '')+"</td>\n";
              cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>"+this.data2[key2]["moneda"]+"</td>\n";
              cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>"+this.$numeral(this.data2[key2]["valor"]).format("0,0.00")+"</td>\n";
              cuerpo += "</tr>\n";
              muestraPoliza = false;
            }else{
              muestraPoliza = true;
            }
          }

          
          cuerpo += "<tr height=20 style='height:15.0pt'>\n";
          for (var i = 0; i < columnas.length; i++) {
            cuerpo += "<td class=xl689618 style='border-left:none;" + xl689618 + "'>" + columnas[i].label + "</td>\n";
          }
          cuerpo += "</tr>\n";
        }

        sumaMontoSol = sumaMontoSol + (this.data[key]["mtosol"] == undefined? 0: this.data[key]["mtosol"]);
        sumaMontoApr = sumaMontoApr + (this.data[key]["mtoapr"] == undefined? 0: this.data[key]["mtoapr"]);
        
        //data
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl689618 style='border-top:none;border-left:none;" + xl689618 + "'>" + filaActual + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+(this.data[key]["idnacion"] == undefined? '': this.data[key]["idnacion"])+"</td>\n";

        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["cliente"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["pais"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='text-align:left;border-style:solid; border-width:thin; mso-number-format:\"Short Date\"';" + xl649618 + "'>" + this.data[key]["vigdesde"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='text-align:left;border-style:solid; border-width:thin; mso-number-format:\"Short Date\"';" + xl649618 + "'>" + this.data[key]["vighasta"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["moneda"] + "</td>\n";
        
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral((this.data[key]["mtosol"] == undefined? 0: this.data[key]["mtosol"])).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral((this.data[key]["mtoapr"] == undefined? 0: this.data[key]["mtoapr"])).format("0,0.00") + "</td>\n";
        
        //var xl649619 = "padding:0px; mso-ignore:padding; color:black; font-size:10.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:@; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl64961t + "'>" + this.data[key]["porcind"] + " </td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["estado"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["uso"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.data[key]["condventa"] == undefined? '': this.data[key]["condventa"]) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["linneg"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["plazo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["observ"] + "</td>\n";
        cuerpo += "</tr>\n";



        filaActual = filaActual + 1;
        polizaAnterior = this.data[key]["linpoliza"];
      }

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 6 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>Total</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>"+sumaMontoSol+"</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>"+sumaMontoApr+"</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 6 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>Approval %</td>\n";

      if (sumaMontoApr == 0){
        porcentajeSuma = 0;  
      }else{
        porcentajeSuma = sumaMontoApr / sumaMontoSol;
        porcentajeSuma = porcentajeSuma * 100;
      }

      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>"+ this.$numeral(porcentajeSuma).format("0%") +"</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'></td>\n";
      cuerpo += "</tr>\n";

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    excel_Prima: function () {
      var cuerpo = "";
      var columnas = this.titles_Prima;
      
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:10.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:10.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";
      
      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>DOCUMENT</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>GLOSSARY</td>\n";
      cuerpo += "<td colspan=" + 1 + " width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>TYPE</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>GLOSSARY</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>DV</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>DECLARACIÓN DE VENTAS</td>\n";
      cuerpo += "<td colspan=" + 1 + " width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>P</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>EN PRODUCCIÓN</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>EM</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>REBAJA DE PRODUCCIÓN O ANULACIÓN</td>\n";
      cuerpo += "<td colspan=" + 1 + " width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>A</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>ANULADO</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PM</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PRIMA MÍNIMA O AJUSTE</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PF</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PROFIT</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>ML</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>MALUS</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>CS</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>COSTO SUSCRIPCIÓN</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 2 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>EXCHANGE RATE: " +this.data2[0]["fecha"] + "</td>\n";
      cuerpo += "</tr>\n";
      for (var key2 in this.data2) {
        cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>"+this.data2[key2]["moneda"]+"</td>\n";
        cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>"+this.$numeral(this.data2[key2]["valor"]).format("0,0.00")+"</td>\n";
        cuerpo += "</tr>\n";
      }

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo += "<td class=xl689618 style='border-left:none;" + xl689618 + "'>" + columnas[i].label + "</td>\n";
      }
      cuerpo += "</tr>\n";  

      
      for (var key in this.data) {  
        //data
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["producto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["doc"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["tipo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["endoso"] + "</td>\n";

        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;"+xl649618+"mso-number-format:\"\@\"''  >"+this.convierteFecha(this.data[key]["femis"])+"</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.data[key]["f_vtas"] == undefined? '': this.data[key]["f_vtas"]) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["totalprimiun"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["montoaseg"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["apr"] + "</td>\n";

        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["asegurado"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["moneda"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["subsidiario"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["year"] + "</td>\n";
        
        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    excel_SiniExcel_pagos: function () {
      var cuerpo = "";
      var columnas = this.titles_SiniExcel_payments;
      
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:10.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:10.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";
      
      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>TYPE OF CUSTOMER</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>GLOSSARY</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>TYPE OF PAYMENT</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>GLOSSARY</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>TYPE OF RECOVERIES</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>GLOSSARY</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>INNOMINADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>D</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>DEVOLUCIÓN DE RECUPEROS</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>AB</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>ABOGADOS</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>N</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>NOMINADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>P</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>INDEMNIZACIÓN</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>BE</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PAGO AL ASEGURADO (INDEMNIZACIÓN O DEVOLUCIÓN)</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>R</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>DEVOLUCIÓN DIRECTO DE RECUPEROS</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>CO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>COBRADOR</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>LI</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>LIQUIDADOR</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>MI</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>RECUPEROS</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PE</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PERITO</td>\n";
      cuerpo += "</tr>\n";
      
      



      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "</tr>\n";

      
      //COLUMNAS
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo += "<td class=xl689618 style='border-left:none;" + xl689618 + "'>" + columnas[i].label + "</td>\n";
      }
      cuerpo += "</tr>\n";  

      
      for (var key in this.data) {  
        //data
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["aseg"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["sujeto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + (this.data[key]["idnacion"] == undefined? '': this.data[key]["idnacion"]) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["noi"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["siniestro"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["recuopag"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["tiporec"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["receptor"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + this.data[key]["fpago"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["monto $"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["sndmoneda"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["monto"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["subsidiaria"] + "</td>\n";

        cuerpo += "</tr>\n";
      }

      var fecha = new Date(this.datosFormulario.hasta );
      var periodo;  
      var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
      var año = fecha.getUTCFullYear();

      periodo =  mes + '-' + año;      

      var nombreexcel =  "Payments (" + periodo + ') ' + this.datosFormulario.pais + '.xls';
      this.export(
        this.generaExcelV2(nombreexcel, cuerpo),
        nombreexcel
      );

    },
    excel_SiniExcel_provisiones: function(){
      var cuerpo = "";
      var columnas = this.titles_SiniExcel_provisions;
      
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:10.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:10.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      // cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>TYPE OF CUSTOMER</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>STATUS</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>GLOSSARY</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>TYPE OF CUSTOMER</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>GLOSSARY</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>TYPE OF CLAIM</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>GLOSSARY</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      // cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>ACT</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>ACTIVO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>INNOMINADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>SIN</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>SINIESTRO</td>\n";
      cuerpo += "</tr>\n";

     // console.log(this.datosFormulario.codPais);
      if (this.datosFormulario.codPais=="PE"){
        cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
        // cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
        cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>CON</td>\n";
        cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>CONTROVERSIA (ACTIVO)</td>\n";
        cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
        cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>N</td>\n";
        cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>NOMINADO</td>\n";
        cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
        cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
        cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
        cuerpo += "</tr>\n";
      }
      
      
      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>ANU</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>ANULADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      if (this.datosFormulario.codPais!="PE"){
        cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>N</td>\n";
        cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>NOMINADO</td>\n";
        cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      } else {
        cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
        cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
        cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      }

      if (this.datosFormulario.codPais=="CL"){
        cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>AVI</td>\n";
        cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>AVISO</td>\n";
      }else{
         cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
         cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      }
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      // cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>APE</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>APELADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      if (this.datosFormulario.codPais=="CL"){
        cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PRO</td>\n";
        cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PRÓRROGA</td>\n";
      }else{
         cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
         cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      }
      cuerpo += "</tr>\n";

       cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      // cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>CER</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>CERRADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      // cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PPA</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PLAN DE PAGOS</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      // cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>REC</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>RECHAZADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "</tr>\n";

       cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      // cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>DES</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>DESISTIDO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      // cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>IND</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>INDEMNIZADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      // cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>IMP</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>IMPUGNADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      // cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>JUD</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>JUDICIALIZADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "</tr>\n";


      //COLUMNAS
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo += "<td class=xl689618 style='border-left:none;" + xl689618 + "'>" + columnas[i].label + "</td>\n";
      }
      cuerpo += "</tr>\n";  

      
      for (var key in this.data2) {  
        //data
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["aseg"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["prod"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["sujeto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + (this.data2[key]["idnacion"] == undefined? '': this.data2[key]["idnacion"]) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["clasif"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["siniestro"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["estado"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["mo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data2[key]["provis"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["tiposini"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["subsidiary"] + "</td>\n";

        cuerpo += "</tr>\n";
      }

          var fecha = new Date(this.datosFormulario.hasta );
          var periodo;          
          var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
          var año = fecha.getUTCFullYear();
          periodo =  mes + '-' + año;      

      var nombreexcel =  "Provisions "+ periodo +" "+ this.datosFormulario.pais+".xls";
      console.log(nombreexcel);
      this.export(
        this.generaExcelV2(nombreexcel, cuerpo),
        nombreexcel
      );

    },

    excel_SiniExcel_provisiones_old: function () {
      var cuerpo = "";
      var columnas = this.titles_SiniExcel_provisions;
      
      var xl689618 = "padding:0px; mso-ignore:padding; color:black; font-size:10.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 = "padding:0px; mso-ignore:padding; color:black; font-size:10.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo += "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";
      
      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>TYPE OF CUSTOMER</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>GLOSSARY</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>STATUS</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>GLOSSARY</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>TYPE OF CLAIM</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl689618 width=698 style='width:526pt;" + xl689618 + "'>GLOSSARY</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>I</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>INNOMINADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>ACT</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>ACTIVO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>AVI</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>AVISO DE IMPAGO</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>N</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>NOMINADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>CER</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>CERRADO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PRO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PRÓRROGA</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>DES</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>DESISTIDO</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>SIN</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>SINIESTRO</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>IND</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>INDEMNIZADO</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=width=698 style='width:526pt;'></td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PPA</td>\n";
      cuerpo += "<td colspan=" + 1 + " class=xl649618 width=698 style='width:526pt;" + xl649618 + "'>PLAN DE PAGOS</td>\n";
      cuerpo += "</tr>\n";



      cuerpo += "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      cuerpo += "</tr>\n";

      
      //COLUMNAS
      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo += "<td class=xl689618 style='border-left:none;" + xl689618 + "'>" + columnas[i].label + "</td>\n";
      }
      cuerpo += "</tr>\n";  

      console.log(thid.data2)      
      for (var key in this.data2) {  
        //data
        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["poliza"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["aseg"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["siniestro"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["sujeto"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + (this.data2[key]["idnacion"] == undefined? '': this.data2[key]["idnacion"]) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["tcliente"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["estado"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["tiposini"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + (this.data2[key]["fec_estado"] == undefined? '': this.convierteFecha(this.data2[key]["fec_estado"])) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data2[key]["provis_total_$"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["mo"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data2[key]["provis_tot"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data2[key]["provis_tot"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.data2[key]["provis_li"] == undefined? '': this.data2[key]["provis_li"]) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + (this.data2[key]["provis_otros"] == undefined? '': this.data2[key]["provis_otros"]) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-style:solid; border-width:thin; mso-number-format:\"\@\"';" + xl649618 + "'>" + (this.data2[key]["festimconfig"] == undefined? '': this.convierteFecha(this.data2[key]["festimconfig"])) + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data2[key]["subsidiaria"] + "</td>\n";

        cuerpo += "</tr>\n";
      }

      var nombreexcel =  "Claims Status (" + this.datosFormulario.hoy + ') ' + this.datosFormulario.pais + '.xls';
      this.export(
        this.generaExcelV2(nombreexcel, cuerpo),
        nombreexcel
      );

    },
  },

  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();    
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>
